import { InspectionCase } from './inspection-case.dto';

export class InspectionFlowPressureCaseDto extends InspectionCase {
  flowRate?: number; // gpm
  declaredPressure?: number; // psi
  measuredPressure?: number; // psi
  rotationSpeed?: number; // rpm
}
export class InspectionFlowPressureCase extends InspectionFlowPressureCaseDto {
  constructor(data: InspectionFlowPressureCaseDto = { isApplicable: true }) {
    super(data);
    this.flowRate = data.flowRate;
    this.declaredPressure = data.declaredPressure;
    this.measuredPressure = data.measuredPressure;
    this.rotationSpeed = data.rotationSpeed;
  }
}
